import { getConnectivityOnline } from "@/domains/offline/connectivity/connectivityStore";
import { clearOfflineData } from "@/domains/offline/db/mivoDb";
import { authApi } from "@/domains/shared/apis/authApi";
import { authMeQueryKey } from "@/domains/shared/hooks/useAuth";
import { queryClient } from "@/domains/shared/services/queryClient";
import {
    isSessionSupersededDetail,
    SESSION_SUPERSEDED_DETAIL,
} from "@/domains/shared/services/sessionSupersededDetail";
import { resetCsrfToken } from "@/domains/shared/services/setupCsrfInterceptor";
import { isPublicAuthPath } from "@/domains/shared/services/sessionExpired";
import { toast } from "sonner";

export { isSessionSupersededDetail, SESSION_SUPERSEDED_DETAIL };

export const SESSION_SUPERSEDED_STORAGE_KEY = "mivo_session_superseded";

export const SESSION_SUPERSEDED_DEFAULT_MESSAGE =
    "Sua sessão foi encerrada porque você entrou em outro dispositivo.";

let handling = false;

export function markSessionSuperseded(): void {
    sessionStorage.setItem(SESSION_SUPERSEDED_STORAGE_KEY, "1");
}

export function consumeSessionSuperseded(): boolean {
    const flagged = sessionStorage.getItem(SESSION_SUPERSEDED_STORAGE_KEY) === "1";

    if (flagged) {
        sessionStorage.removeItem(SESSION_SUPERSEDED_STORAGE_KEY);
    }

    return flagged;
}

export async function forceLogoutSuperseded(
    message: string = SESSION_SUPERSEDED_DEFAULT_MESSAGE,
): Promise<void> {
    if (handling) {
        return;
    }

    handling = true;
    try {
        resetCsrfToken();
        queryClient.removeQueries({ queryKey: authMeQueryKey });

        if (isPublicAuthPath(window.location.pathname)) {
            return;
        }

        markSessionSuperseded();

        if (getConnectivityOnline()) {
            try {
                await authApi.logout();
            } catch {
                /* ignore — superseded responses already clear HttpOnly cookies server-side */
            }

            await clearOfflineData();
        }

        toast.error(message);
        window.location.assign("/login");
    } finally {
        handling = false;
    }
}
